"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
var React = require("react");
var Loader_style_1 = require("./Loader.style");
exports.Loader = function (props) {
    var _a = props.size, size = _a === void 0 ? 1 : _a, _b = props.color, color = _b === void 0 ? '#006bdf' : _b, _c = props.inline, inline = _c === void 0 ? false : _c, type = props.type;
    var loaderType = function (type) {
        switch (type) {
            case 'dots':
                return (React.createElement(Loader_style_1.default.LoaderDot, __assign({ type: type, size: size, color: color }, props),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null)));
            default:
                return React.createElement(Loader_style_1.default.Loader, __assign({ type: type, size: size, color: color, inline: inline }, props));
        }
    };
    return loaderType(type);
};
exports.default = exports.Loader;
//# sourceMappingURL=Loader.js.map